import { Button, Col, Modal, Row } from "antd";
import { useEffect, useState } from "react";
import { GameSession } from "../../API";
import { FormattedMessage } from "react-intl";
const MAX_SESSIONS = 2;
type ModalSessionExitsProps = {
  sessions: Array<{
    __typename: "GameSession";
    PK?: string | null;
    SK?: string | null;
    lang?: string | null;
    currency?: string | null;
    username?: string | null;
    live?: string | null;
    gameId?: string | null;
    demo?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    liveUpdatedAt?: string | null;
    level?: string | null;
    buyIn?: number | null;
    expenses?: number | null;
    winnings?: number | null;
    balance?: number | null;
    game?: {
      __typename: "Game";
      PK?: string | null;
      SK?: string | null;
      id?: string | null;
      name?: string | null;
      category?: string | null;
      subcategory?: string | null;
      gamedata?: string | null;
      showLabel?: string | null;
      apiOperator?: string | null;
      urlEndPoint?: string | null;
      vendor?: string | null;
      updatedAt?: string | null;
      gameLaunchUrl?: string | null;
    } | null;
  } | null>;
  playedGameId: string;
  onContinue: () => void;
  onRecovery: (sessionData: GameSession) => void;
  onCloseSession: (sessionData: GameSession) => void;
};

const ModalSessionExists: React.FC<ModalSessionExitsProps> = ({
  sessions,
  onContinue,
  onRecovery,
  onCloseSession,
  playedGameId,
}) => {
  const [gameWithSameId, setGameWithSameId] = useState<boolean>(false);
  useEffect(() => {
    if (sessions) {
    }
  }, []);
  return (
    <div className="modal-exists-session">
      {!gameWithSameId && sessions.length < MAX_SESSIONS && (
        <>
          <Row>
            <Col span={12} offset={6}>
              <Button
                className="btn-continue-game"
                block
                onClick={() => {
                  if (onContinue) onContinue();
                }}
              >
                <FormattedMessage id="session.game.continue" />
              </Button>
            </Col>
          </Row>
          <hr />
        </>
      )}
      {sessions.map((s, i) => {
        const gamedata = JSON.parse(s.game.gamedata);
        if (playedGameId === s.game.id && !gameWithSameId)
          setGameWithSameId(true);

        return (
          <div key={i}>
            <Row gutter={20}>
              <Col xs={4}>
                <img
                  alt={gamedata.details.title}
                  className="modal-exist-session-image"
                  src={gamedata.details.thumbnails["300x300"]}
                  style={{ width: "100%" }}
                />
              </Col>
              <Col xs={20}>
                <p>
                <FormattedMessage id="session.game.open" /> <b>{gamedata.title}</b>
                </p>

                <p>
                <FormattedMessage id="session.game.balance" /> <b>{s.balance}</b> {s.currency}
                </p>
                <p><FormattedMessage id="session.game.proceed" /></p>
              </Col>
            </Row>
            <hr />
            <Row gutter={20}>
              <Col span={10}>
                <Button
                  className="btn-recovery-session"
                  block
                  onClick={() => {
                    if (onRecovery) onRecovery(s);
                  }}
                >
                  <FormattedMessage id="session.game.restore" />
                </Button>
              </Col>
              <Col span={10} offset={4}>
                <Button
                  className="btn-close-session"
                  block
                  onClick={() => {
                    if (onCloseSession) onCloseSession(s);
                  }}
                >
                  <FormattedMessage id="session.game.close" />
                </Button>
              </Col>
            </Row>
            <hr />
          </div>
        );
      })}
    </div>
  );
};

export default ModalSessionExists;
